import { TrialBalanceHandler } from "./TrialBalanceHandler";
import { AuxiliaryBookHandler } from "./AuxiliaryBookHandler";
import { FinancialReportHandler } from "./FinancialReportHandler";
import { TaxReportHandler } from "./TaxReportHandler";
import { BaseReportHandler } from "./BaseReportHandler";

/**
 * ReportHandlerFactory
 * Directs report requests to the appropriate specialized handler.
 */
export class ReportHandlerFactory {
    static getHandler(data) {
        const type = data.metadata.report_type;

        switch (type) {
            case 'trial_balance':
                return new TrialBalanceHandler(data);
            case 'auxiliary_book':
                return new AuxiliaryBookHandler(data);
            case 'balance_sheet':
            case 'income_statement':
                return new FinancialReportHandler(data);
            case 'tax_report':
            case 'sales_report':
            case 'purchase_report':
                return new TaxReportHandler(data);
            default:
                // Fallback to a basic handler if type not found
                return new BaseReportHandler(data);
        }
    }
}
